import api from "./api";

// Keep all report-related API calls in one place.
const reportService = {
  getOwners: async () => {
    const res = await api.get("/reports/owners");
    return res.data?.data || [];
  },

  generateDailyReport: async (dailyDate) => {
    const res = await api.get("/reports/generate", {
      params: { type: "daily", dailyDate }
    });
    return res.data?.data || null;
  },

  generateMonthlyReport: async (month, year) => {
    const res = await api.get("/reports/generate", {
      params: { type: "monthly", month, year }
    });
    return res.data?.data || null;
  },

  generateAssetReport: async () => {
    const res = await api.get("/reports/generate", {
      params: { type: "asset" }
    });
    return res.data?.data || null;
  },

  generateDebtorsReport: async () => {
    const res = await api.get("/reports/generate", {
      params: { type: "debtors" }
    });
    return res.data?.data || null;
  },

  generateOwnerReport: async (ownerId, month, year) => {
    const res = await api.get("/reports/owner", {
      params: { ownerId, month, year }
    });
    return res.data?.data || null;
  },

  generatePlatformReport: async (type) => {
    const res = await api.get("/reports/platform", {
      params: { type }
    });
    return res.data?.data || null;
  }
};

export default reportService;
